"use strict";

exports.__esModule = true;
function createTokenClass() {
	return function (value) {
		if (value) {
			this.v = value;
		}
	};
}

exports.createTokenClass = createTokenClass;


//////////////////
// WEBPACK FOOTER
// ./node_modules/linkifyjs/lib/linkify/core/tokens/create-token-class.js
// module id = 381
// module chunks = 0